import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import styled from 'styled-components';

const Item = styled.div`
	width: 100%;
	height: 200px;
	box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.32);
	border-radius: 0.25rem;
	padding: 0.75rem;
	background-color: #E6E6E690;
	overflow: hidden;
	transition: transform ease-in-out 0.3s;
	cursor: pointer;
	&:hover {
		transform: scale(1.0125);
	}
`;

const card = {
	box: {
		backgroundColor: '#FFFFFF',
		height: '100%',
		padding: '0.75rem',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '1rem'
	},
	top: {
		display: 'flex',
		alignItems: 'center'
	},
	title: {
		width: '100%',
		fontWeight: 'bold',
		textAlign: 'center'
	},
	amount: {
		textAlign: 'center',
		fontSize: '2rem',
		fontWeight: '600'
	}
}

const Cards = () => {
	return (
		<Grid container spacing={4}>
				<Grid item xs={12} md={6} lg={4}>
					<Item>
						<Box sx={card.box}>
							<Box sx={card.top}>
								<Typography sx={card.title}>Total Transfer Requests</Typography>
							</Box>
							<Typography sx={card.amount}>N40,234,225.02</Typography>
						</Box>
					</Item>
				</Grid>
				<Grid item xs={12} md={6} lg={4}>
					<Item>
						<Box sx={card.box}>
							<Box sx={card.top}>
								<Typography sx={card.title}>Total Successful Transfers</Typography>
							</Box>
							<Typography sx={card.amount}>N20,234,225.02</Typography>
						</Box>
					</Item>
				</Grid>
				<Grid item xs={12} md={6} lg={4}>
					<Item>
						<Box sx={card.box}>
							<Box sx={card.top}>
								<Typography sx={card.title}>Total Pending Transfers</Typography>
							</Box>
							<Typography sx={card.amount}>N19,766,775.98</Typography>
						</Box>
					</Item>
				</Grid>
			</Grid>
	)
}

export default Cards;